import { Stack, Typography } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import CustomChip from 'src/components/mui/chip'
import Page from 'src/components/Page'
import PageHeader from 'src/components/page-header'
import FindUser from 'src/views/user/FindUser'

const UserList = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const field = searchParams.get("field") || "";
    const q = searchParams.get("q") || "";
    const [reload, setReload] = useState(0)
    const [selected, setSelected] = useState({})

    const handleClick = () => {
        window.opener.userReceiver(selected);
        self.close();
    }

    return (
        <Page title="Users">
            <Grid container spacing={6}>
                <PageHeader
                    title={
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center">
                            <Typography variant='h5' color='#666CFF'>
                                고객 검색
                            </Typography>
                            <Grid
                                justifyContent="flex-end"
                                alignItems="center">
                                    <Stack spacing={2} direction="row">
                                        <Button variant='contained' onClick={handleClick}> 적용 </Button>
                                        <Button variant='outlined' color='secondary' onClick={() => {self.close()}}> 취소 </Button>
                                    </Stack>                                
                            </Grid>
                        </Grid>
                    }
                    subtitle={
                        <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'center', width: '100%' }}>
                            <Typography variant='body2'>선택된 고객 리스트를 보여줍니다.</Typography>
                            {selected?.username && (
                                <CustomChip
                                    skin='light'
                                    size='small'
                                    label={selected.username}
                                    color='primary'
                                    sx={{ height: 20, fontSize: '0.75rem', fontWeight: 500, borderRadius: '10px', ml: 2 }}
                                />
                            )}
                        </Box>
                    }
                />                
                <Grid item xs={12}>                    
                    <FindUser field={field} q={q} reload={reload} setReload={setReload} selected={selected} setSelected={setSelected} />
                </Grid>
            </Grid>
        </Page>
    )
}

export default UserList